const HACKLE_DATA = {
  EVENT : {
    '진단test 시작' : {
      key : 'Diagnosis_start', // event key
      value : null, // type : boolean, string(글자수 64 제한), number 
      properties : {}
    },
    '진단문항풀이 Pass' : {
      key : 'Skip_clicked',
      value : null,
      properties : {}
    },
    '학습 시작' : {
      key : 'Learning_start',
      value : null,
      properties : {}
    },
    '학습연습장 초기화' : {
      key : 'Notepad_reset',
      value : null,
      properties : {}
    },
    '학습연습장 시작' : {
      key : 'Notepad_start',
      value : null,
      properties : {}
    },
    '개념영상 시작' : {
      key : 'Video_start',
      value : null,
      properties : {}
    },
    '회원가입 완료' : {
      key : 'sign_up',
      value : null,
      properties : {}
    },
    '학습노트_코스학습 조회' : {
      key : 'Progress_report',
      value : null,
      properties : {}
    },
    '문항별 오답확인' : {
      key : 'Incorrect_answers_check',
      value : null,
      properties : {}
    },
    '진단test 종료' : {
      key : 'Diagnosis_complete',
      value : null,
      properties : {}
    },
    '코스학습메인 조회' : {
      key : 'courseLearning_select',
      value : null,
      properties : {}
    },
    '학습 종료' : {
      key : 'Learning_complete',
      value : null,
      properties : {}
    },
    '학습결과 조회' : {
      key : 'Learning_result',
      value : null,
      properties : {}
    },
    '주제학습메인 조회' : {
      key : 'topicLearning_select',
      value : null,
      properties : {}
    },
    'ocr히스토리 조회' : {
      key : 'OCR_history',
      value : null,
      properties : {}
    },
    'ocr소주제추천 조회' : {
      key : 'OCR_recommendation',
      value : null,
      properties : {}
    },
    'ocr학습메인 조회' : {
      key : 'OCR_camera_select',
      value : null,
      properties : {}
    },
    'on-boarding화면 조회' : {
      key : 'on_boarding',
      value : null,
      properties : {}
    },
    '상품 구매화면 조회' : {
      key : 'purchase_page_view',
      value : null,
      properties : {}
    },
    '상품 구매완료' : {
      key : 'purchase_complete',
      value : null,
      properties : {}
    },
    '메인컨셉비디오 클릭' : {
      key: 'Mainvideo_click',
      value : null,
      properties : {}
    },
  },

  TYPE : {
    PURCHASE_PAGE_ONBOARDING_VIEW : 'PURCHASE_PAGE_ONBOARDING_VIEW', // 온보딩 마지막 화면에 보여지는 상품 상세 페이지 로딩이 완료되었을 때
    PURCHASE_PAGE_LEARNING_VIEW : 'PURCHASE_PAGE_LEARNING_VIEW', // 온보딩 외 상품 상세 페이지 로딩이 완료되었을 때
    // 상품추가로 삭제됨(2022-07-06)
    PURCHASE_BTN_ONBOARDING_CLICK : 'PURCHASE_BTN_ONBOARDING_CLICK', // 상품 구매를 위해 결제하기버튼이 "클릭"되었을 때 (from 온보딩)
    // PURCHASE_BTN_WELCOME_CLICK : 'PURCHASE_BTN_WELCOME_CLICK', // 상품 구매를 위해 결제하기버튼이 "클릭"되었을 때 (from 재방문)
    // PURCHASE_BTN_REPORT_CLICK : 'PURCHASE_BTN_REPORT_CLICK', // 상품 구매를 위해 결제하기버튼이 "클릭"되었을 때 (from 학습노트)
    PURCHASE_BTN_LEARNING_CLICK : 'PURCHASE_BTN_LEARNING_CLICK', // 상품 구매를 위해 결제하기버튼이 "클릭"되었을 때 (from 학습)
    PURCHASE_COMPLETE : 'PURCHASE_COMPLETE', // Premium 전환된 메인화면 로딩이 완료되었을 때
    // 상품추가로 변경됨(2022-07-06)
    POP_WELCOME_BTN_CLICK : 'POP_WELCOME_BTN_CLICK', // 상품 구매를 위해 결제하기버튼이 "클릭"되었을 때 (from 재방문팝업)
    POP_REPORT_BTN_CLICK : 'POP_REPORT_BTN_CLICK', // 상품 구매를 위해 결제하기버튼이 "클릭"되었을 때 (from 학습노트)
    PURCHASE_BTN_ONBADING_1_1CLICK : 'PURCHASE_BTN_ONBADING_1_1CLICK', // 상품 구매를 위해 결제하기1.1버튼이 "클릭"되었을 때 (from 온보딩)
    PURCHASE_BTN_ONBADING_1_2CLICK : 'PURCHASE_BTN_ONBADING_1_2CLICK', // 상품 구매를 위해 결제하기1.2버튼이 "클릭"되었을 때 (from 온보딩)
    PURCHASE_BTN_ONBADING_1_3CLICK : 'PURCHASE_BTN_ONBADING_1_3CLICK', // 상품 구매를 위해 결제하기1.3버튼이 "클릭"되었을 때 (from 온보딩)
    PURCHASE_BTN_ONBADING_1_4CLICK : 'PURCHASE_BTN_ONBADING_1_4CLICK', // 상품 구매를 위해 결제하기1.4버튼이 "클릭"되었을 때 (from 온보딩)
    PURCHASE_BTN_LEARNING_4_1CLICk : 'PURCHASE_BTN_LEARNING_4_1CLICk', // 상품 구매를 위해 결제하기4.1버튼이 "클릭"되었을 때 (from 온보딩 외)
    PURCHASE_BTN_LEARNING_4_2CLICk : 'PURCHASE_BTN_LEARNING_4_2CLICk', // 상품 구매를 위해 결제하기4.2버튼이 "클릭"되었을 때 (from 온보딩 외)
    PURCHASE_BTN_LEARNING_4_3CLICk : 'PURCHASE_BTN_LEARNING_4_3CLICk', // 상품 구매를 위해 결제하기4.3버튼이 "클릭"되었을 때 (from 온보딩 외)
    PURCHASE_BTN_LEARNING_4_4CLICk : 'PURCHASE_BTN_LEARNING_4_4CLICk', // 상품 구매를 위해 결제하기4.4버튼이 "클릭"되었을 때 (from 온보딩 외)
    MATHFARM_CLICK : 'MATHFARM_CLICK' // 홈 화면내 [매쓰팜] 버튼을 '클릭'했을 때
  },

  EVENT_INFO : {
    PURCHASE_PAGE_ONBOARDING_VIEW : {
      key : 'purchase_page_onboarding_view',
      value : null,
      properties : {}
    },
    PURCHASE_PAGE_LEARNING_VIEW : {
      key : 'purchase_page_learning_view',
      value : null,
      properties : {}
    },
    PURCHASE_COMPLETE : {
      key : 'purchase_complete',
      value : null,
      properties : {}
    },
    POP_WELCOME_BTN_CLICK : {
      key : 'pop_welcome_btn_click',
      value : null,
      properties : {}
    },
    POP_REPORT_BTN_CLICK : {
      key : 'pop_report_btn_click',
      value : null,
      properties : {}
    },
    PURCHASE_BTN_ONBOARDING_CLICK : {
      key : 'purchase_btn_onboarding_click',
      value : null,
      properties : {}
    },
    PURCHASE_BTN_LEARNING_CLICK : {
      key : 'purchase_btn_learning_click',
      value : null,
      properties : {}
    },
    PURCHASE_BTN_ONBADING_1_1CLICK : {
      key : 'purchase_btn_onboarding_1.1click',
      value : null,
      properties : {}
    },
    PURCHASE_BTN_ONBADING_1_2CLICK : {
      key : 'purchase_btn_onboarding_1.2click',
      value : null,
      properties : {}
    },
    PURCHASE_BTN_ONBADING_1_3CLICK : {
      key : 'purchase_btn_onboarding_1.3click',
      value : null,
      properties : {}
    },
    PURCHASE_BTN_ONBADING_1_4CLICK : {
      key : 'purchase_btn_onboarding_1.4click',
      value : null,
      properties : {}
    },
    PURCHASE_BTN_LEARNING_4_1CLICk : {
      key : 'purchase_btn_learning_4.1click',
      value : null,
      properties : {}
    },
    PURCHASE_BTN_LEARNING_4_2CLICk : {
      key : 'purchase_btn_learning_4.2click',
      value : null,
      properties : {}
    },
    PURCHASE_BTN_LEARNING_4_3CLICk : {
      key : 'purchase_btn_learning_4.3click',
      value : null,
      properties : {}
    },
    PURCHASE_BTN_LEARNING_4_4CLICk : {
      key : 'purchase_btn_learning_4.4click',
      value : null,
      properties : {}
    },
    MATHFARM_CLICK : {
      key : 'mathfarm_click',
      value : null,
      properties : {}
    }
  },

  VIEW : {
    SELECT_LEARNING : {
      key : 6,
      variation_d : 'A'
    },
    ANSWERING_QUESTIONS : {
      key : 7,
      variation_d : 'A'
    },
    INTRODUCTION : {
      key : 8,
      variation_d : 'A'
    },
    INIT_ONBOARDING : {
      key : 9,
      variation_d : 'A'
    },
    LEARNING_RESULT : {
      key : 10,
      variation_d : 'A'
    },
    INTRODUCTION_PAYMENT : {
      key : 11,
      variation_d : 'A'
    },
    MAIN_TUTORIAL_GUIDE : {
      key : 13,
      variation_d : 'A'
    },
    ANSWERING_QUESTIONS_BUTTON : {
      key : 14,
      variation_d : 'A'
    },
    MAIN_GAME_BANNER : {
      key : 15,
      variation_d : 'A'
    }
  }
};

export default HACKLE_DATA;

